import './App.css';

function App() {

  function glitch(T, text) {
    return(
      <div className="glitch">
        <T id="w0" class="glitch_w0">{text}</T>
        <T id="w1" class="glitch_w1">{text}</T>
        <T id="w2" class="glitch_w2">{text}</T>
      </div>
    )
  }

  return (
    <div className="App">
      <a href="https://www.linkedin.com/in/lucasguzmanfinn/">
        {glitch("p", "linkedin/lucasguzmanfinn")}
      </a>
      {glitch("h1", "sorry, WIP")}
      <a href="https://github.com/lgf00">
        {glitch("p", "github.com/lgf00")}
      </a>

    </div>
  );
}

export default App;
